import React from 'react';
import {
  Box,
  Container,
  Typography,
  Stack,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSubscriptionFeaturesEnabled } from '../../utils/subscriptionFeatures';

const Footer = () => {
  const { t } = useTranslation();
  const subscriptionFeaturesEnabled = useSubscriptionFeaturesEnabled();
  const currentYear = new Date().getFullYear();
  
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        py: 2,
        px: 1,
        flexShrink: 0,
        width: '100%',
        backgroundColor: (theme) => theme.palette.background.paper,
        color: (theme) => theme.palette.text.primary,
        borderTop: 1,
        borderColor: (theme) => theme.palette.divider,
        zIndex: (theme) => theme.zIndex.drawer + 1
      }}
    >
      <Container maxWidth={false} sx={{ px: { xs: 1, sm: 2 } }}>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          spacing={{ xs: 1, sm: 2 }}
          justifyContent={{ xs: 'space-between', sm: 'space-between' }}
          alignItems={{ xs: 'center', sm: 'center' }}
          sx={{ flexWrap: 'nowrap', width: '100%' }}
        >
          <Box sx={{ order: 1, display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flexWrap: 'nowrap' }}>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Typography 
                variant="body2" 
                component="span" 
                sx={{ 
                  fontWeight: 600,
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                  color: (theme) => theme.palette.text.secondary,
                }}
              >
                BANDSPACE ©{currentYear}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ order: { xs: 2, sm: 2 }, ml: 'auto', minWidth: 0 }}>
            <Stack 
              direction="row" 
              spacing={{ xs: 1, sm: 2 }} 
              alignItems="center"
              sx={{ flexWrap: 'nowrap' }}
            >
              {subscriptionFeaturesEnabled && (
                <Link to="/pricing" style={{ color: 'inherit', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                  <Typography variant="body2" sx={{ whiteSpace: 'nowrap', color: (theme) => theme.palette.text.secondary, '&:hover': { color: (theme) => theme.palette.text.primary }, transition: 'color 0.3s ease' }}>{t('footer.pricing', 'Pricing')}</Typography>
                </Link>
              )}
              <Link to="/terms" style={{ color: 'inherit', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap', color: (theme) => theme.palette.text.secondary, '&:hover': { color: (theme) => theme.palette.text.primary }, transition: 'color 0.3s ease' }}>{t('footer.terms')}</Typography>
              </Link>
              <Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap', color: (theme) => theme.palette.text.secondary, '&:hover': { color: (theme) => theme.palette.text.primary }, transition: 'color 0.3s ease' }}>{t('footer.privacy')}</Typography>
              </Link>
              <Link to="/cookies" style={{ color: 'inherit', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap', color: (theme) => theme.palette.text.secondary, '&:hover': { color: (theme) => theme.palette.text.primary }, transition: 'color 0.3s ease' }}>{t('footer.cookies')}</Typography>
              </Link>
              <Link to="/contact" style={{ color: 'inherit', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap', color: (theme) => theme.palette.text.secondary, '&:hover': { color: (theme) => theme.palette.text.primary }, transition: 'color 0.3s ease' }}>{t('footer.contact')}</Typography>
              </Link>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer; 